import classnames from 'classnames';
import isFunction from 'lodash/isFunction';
import { Dropdown } from 'primereact/dropdown';
import React from 'react';
import { SegmentEventTypes } from '../../data/tracking';
import Analytics from '../../utils/Analytics';
import LabelWrapper from '../LabelWrapper.component';

export const WrappedDropdown = props => {
	const {
		className,
		isInputInvalid,
		id,
		dataqa = 'common',
		onFocus,
		onBlur,
		autoCompleteName,
		autoCompleteOnChange,
		showServicesOnly,
		rateOptionValue,
		...config
	} = props;

	const focusHandler = e => {
		Analytics.trackSegmentEvent({
			trackingData: {
				field_type: 'dropdown',
				field_name_dataqa: `ui-dropdown-${dataqa}`,
			},
			eventType: SegmentEventTypes.UserInputStarted,
		});

		if (isFunction(onFocus)) {
			onFocus(e);
		}
	};

	const blurHandler = e => {
		Analytics.trackSegmentInputEvent({
			trackingData: {
				field_type: 'dropdown',
				field_name_dataqa: `ui-dropdown-${dataqa}`,
			},
			eventType: SegmentEventTypes.UserInputCompleted,
			fieldValue: e.target?.value,
		});

		if (isFunction(onBlur)) {
			onBlur(e);
		}
	};

	const dropdownClassName = classnames(className, {
		'invalid-component': isInputInvalid,
	});

	return (
		<div className="common-ui-dropdown" data-qa={`ui-dropdown-${dataqa}`}>
			{autoCompleteName ? (
				<>
					<Dropdown
						className={dropdownClassName}
						inputId={id}
						dataqa={`ui-dropdown-${dataqa}`}
						onFocus={focusHandler}
						onBlur={blurHandler}
						{...config}
					/>
					{/* This is a hidden input that when populated by the browser updates its sister component since this functinality isn't supported by the UI library */}
					<input
						style={{ position: 'absolute', top: '-1000px' }}
						aria-hidden="true"
						autoComplete={autoCompleteName}
						onChange={e => {
							autoCompleteOnChange(e);
						}}
					/>
				</>
			) : (
				<Dropdown
					className={dropdownClassName}
					inputId={id}
					dataqa={`ui-dropdown-${dataqa}`}
					onFocus={focusHandler}
					onBlur={blurHandler}
					{...config}
				/>
			)}
		</div>
	);
};

export const WrappedDropdownWithLabel = LabelWrapper(WrappedDropdown);
